import { ConsumptionAdjustmentMethod } from 'views/order-feed/features/my-supply-plan/features/ofd-2.0/types/consumption-adjustment-method.enum';
import { OrderFeed } from 'types/language/order-feed.lang';

//GET
export interface OfdSettings {
  isOfdEnabled: boolean;
  placeRecommendedOrdersAutomatically: boolean;
  capacityBuffer: number | undefined;
  siloCapacity: number;
  consumptionBufferDays: number;
  buffer: number;
  consumptionRateAdjustmentMethod: ConsumptionAdjustmentMethod;
  consumptionRateAdjustmentDays: number;
  manualConsumptionRateCoefficient: number | null;
  currentConsumptionRate: number; //estimated Subtraction (consumptionRate)
  minimumRecommendationQuantity: number;
  orderFrequency: number | null;
  deliveryExpected: boolean; // if delivery expected is true, a delivery arrives today. if false, no delivery is expected
  deliveredQuantity: number; //estimated Addition
  originalConsumptionRate: number | null; //historical average (consumptionRate)
  manualInventory: Inventory | null;
  inventoryExplanation: InventoryExplanation;
  nextDeliveryExplanation: NextDeliveryExplanation | null;
}

interface NextDeliveryExplanation {
  utcDate: string;
  startingInventory: number;
  startingPercentOfCapacity: number;
  events: Event[];
  endingInventory: number;
  endingPercentOfCapacity: number;
  lowInventory: boolean;
  manualUpdateNeeded: boolean | null;
  // issues: string[];
}

interface InventoryExplanation {
  utcDate: string;
  startingInventory: number;
  startingPercentOfCapacity: number;
  events: Event[];
  endingInventory: number;
  endingPercentOfCapacity: number;
  lowInventory: boolean;
  manualUpdateNeeded: boolean;
  // issues: string[];
}

export enum EventName {
  DELIVERY = 'Delivery',
  FORECAST = 'Forecast',
  MANUAL_UPDATE = 'Manual update',
  CONSUMPTION = 'Consumption',
  EXPECTED_CONSUMPTION = 'Exp. Consumption',
}

export const EventNameToTranslationKey: Record<EventName, keyof OrderFeed['ofdMySupplyPlan']['feedInventory']['tooltip']['events']> = {
  [EventName.DELIVERY]: 'delivery',
  [EventName.FORECAST]: 'forecast',
  [EventName.MANUAL_UPDATE]: 'manualUpdate',
  [EventName.CONSUMPTION]: 'consumption',
  [EventName.EXPECTED_CONSUMPTION]: 'expectedConsumption',
};

interface Inventory {
  inventory: number; //starting inventory
  updatedDate: string;
  afterDelivery: boolean | null;
  updatedByEmail: string;
}

//PUT
export interface OfdSettingsRequest {
  minimumRecommendationQuantity: number;
  orderFrequency: number;
}

//PUT
export interface ConsumptionRateUpdateRequest {
  consumptionRateAdjustmentDays: number; //days used as historical average
  manualConsumptionRateCoefficient: number;
}
//PUT
//"Feed Reserve"
export interface BufferSettingsUpdateRequest {
  capacityBuffer: number; //maxSiloCapacity
  consumptionBufferDays: number; //days
}

//PUT
export interface ManualInventoryUpdateRequest {
  inventory: number;
  afterDelivery: boolean | null;
}

export interface InventoryLog {
  utcDate: string;
  startingInventory: number;
  events: Event[];
}

export interface Event {
  updatedBy: string | null;
  time: string;
  adjustment: number;
  event: EventName;
  dataInput: string;
}

//Get
export interface FeedReserve {
  feedStrategyId: number;
  itemNumber: string;
  itemName: string;
  fromWeight: number;
}

export interface ConsumptionRateOptions {
  days: number;
  kg: number;
}

export interface Timeline {
  buffer: number;
  siloCapacity: number;
  inventory: ObjectKeys[];
  recommendations: ObjectKeys[];
  skippedRecommendations: string[];
  orders: ObjectKeys[];
  openSlots: string[];
  consumption: ObjectKeys[];
}

export interface ObjectKeys {
  date: string;
  value: number;
}

export interface FeedRunOut {
  date: string;
}
